import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getCellStyles } from './hooks/getCellStyles'

export const HeadRow = styled.tr`
  background-color: ${Color.Grey100};
`

export const HeadCell = styled.th`
  ${getCellStyles()}
`

export const BodyCell = styled.td`
  ${getCellStyles()};
  padding-block: ${Spacing.S6};
`
